<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ghkNvf/tc-custom/9781429962858.jpg?1737197407794" alt="This image is the cover for the book True Memoirs of Little K"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">True Memoirs of Little K
      </h1>
      <p class="bookDescription body article font2">
        <p>Exiled in Paris, tiny, one-hundred-year-old Mathilde Kschessinska sits down to write her memoirs before all that she believes to be true is forgotten. A lifetime ago, she was the vain, ambitious, impossibly charming <i>prima ballerina assoluta </i>of the tsar's Russian Imperial Ballet in St. Petersburg. Now, as she looks back on her tumultuous life, she can still recall every slight she ever suffered, every conquest she ever made.<br/><br/>Kschessinka's riveting storytelling soon thrusts us into a world lost to time: that great intersection of the Russian court and the Russian theater. Before the revolution, Kschessinska dominated that world as the greatest dancer of her age. At seventeen, her crisp, scything technique made her a star. So did her romance with the tsarevich Nicholas Romanov, soon to be Nicholas II. It was customary for grand dukes and sons of tsars to draw their mistresses from the ranks of the ballet, but it was not customary for them to fall in love.<br/><br/>The affair could not endure: when Nicholas ascended to the throne as tsar, he was forced to give up his mistress, and Kschessinska turned for consolation to his cousins, two grand dukes with whom she formed an infamous ménage à trois. But when Nicholas's marriage to Alexandra wavered after she produced girl after girl, he came once again to visit his Little K. As the tsar's empire—one that once made up a third of the world—began its fatal crumble, Kschessinka's devotion to the imperial family would be tested in ways she could never have foreseen.<br/><br/>In Adrienne Sharp's magnificently imagined novel, the last days of the three-hundred-year-old Romanov empire are relived. Through Kschessinska's memories of her own triumphs and defeats, we witness the stories that changed history: the seething beginnings of revolution, the blindness of the doomed court, the end of a grand, decadent way of life that belonged to the nineteenth century. Based on fact, <i>The True Memoirs of Little K </i>is historical fiction as it's meant to be written: passionately eventful, crammed with authentic detail, and alive with emotions that resonate still.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adrienne Sharp
      </h2>
      
      <p class="authorDescription body article"><P>Adrienne Sharp entered the world of ballet at age seven and trained at the prestigious Harkness Ballet in New York. She received her M.A. with honors from the Writing Seminars at the Johns Hopkins University and was awarded a Henry Hoyns Fellowship at the University of Virginia. She has been a fiction fellow at MacDowell, the Virginia Center for the Creative Arts, and the Squaw Valley Writer's Conference. She is the author of <I>White Swan</I>, <I>Black Swan </I>and <I>The Sleeping Beauty</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c31c3d60